import type { ReactElement } from "react";
import { KeyValuePanel } from "~/components/Common/KeyValuePanel";

export function HeadersTab(): ReactElement {
    return <KeyValuePanel panelName="Headers" />;
}
